import React from 'react';

import styles from './tableStyles';

export const ROW_HEIGHTS = { SMALL: 'small', MEDIUM: 'medium', LARGE: 'large' };

const BasicTableContext = new React.createContext({
  columns: [],
  rowHeight: ROW_HEIGHTS.MEDIUM
});

const Row = ({ rowContent, key, isHeading = false, rowHeight = ROW_HEIGHTS.MEDIUM }) => {
  const rowStyle = isHeading ? styles.tableHeading : styles.tableEntry;
  const rowHeightStyle = `
    ${rowHeight === ROW_HEIGHTS.SMALL && styles.smallRowHeight}
    ${rowHeight === ROW_HEIGHTS.LARGE && !isHeading && styles.largeRowHeight}
  `;

  return (
    <div className={`${rowStyle} ${rowHeightStyle}`} key={key}>
      {rowContent}
    </div>
  );
};

export const Column = ({ idx: columnNum, heading }) => {
  return (
    <BasicTableContext.Consumer>
      {ctx => {
        return (
          <div className={styles.tableColumn}>
            {heading.length > 0
              ? Row({
                  rowContent: heading,
                  key: 0,
                  isHeading: true,
                  rowHeight: ctx.rowHeight
                })
              : ''}
            {ctx.columns[columnNum].map((rowContent, idx) =>
              Row({ rowContent, key: idx + 1, rowHeight: ctx.rowHeight })
            )}
          </div>
        );
      }}
    </BasicTableContext.Consumer>
  );
};

class BasicTable extends React.Component {
  render() {
    return (
      <BasicTableContext.Provider
        value={{ columns: this.props.columns, rowHeight: this.props.rowHeight }}
      >
        <div className={styles.tableColumns}>{this.props.children}</div>
      </BasicTableContext.Provider>
    );
  }
}

export default BasicTable;
